import { render, staticRenderFns } from "./page-version.vue?vue&type=template&id=1f939f35&scoped=true&"
import script from "./page-version.vue?vue&type=script&lang=js&"
export * from "./page-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f939f35",
  null
  
)

export default component.exports